"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var date_util_1 = require("@hikakaku/shared/util/date_util");
var RichText_1 = __importDefault(require("@hikakaku/shared/components/estimate/message/RichText"));
var formattedCreatedAt = function (createdAt) {
    return (0, date_util_1.formatJa)(createdAt, 'yyyy/MM/dd(eee) HH:mm');
};
var shouldShowItemCountLabel = function (itemNames) { return (itemNames.length > 1); };
var RequestItem = function (props) {
    var _a = props.requestItem, request = _a.request, isOpened = _a.isOpened;
    var itemBoxClass = (0, classnames_1.default)("unreadRequestWindow-RequestItem_Box", {
        "unreadRequestWindow-RequestItem_Box-opened": isOpened
    });
    var itemNameClass = (0, classnames_1.default)("unreadRequestWindow-RequestItem_ItemName", {
        "unreadRequestWindow-RequestItem_ItemName-short": shouldShowItemCountLabel(request.item_names)
    });
    return (react_1.default.createElement("div", { className: itemBoxClass, onClick: function () { return props.onClickRequestItemBox(request.id); } },
        react_1.default.createElement("div", { className: "unreadRequestWindow-RequestItem_StoreIconWrapper" },
            react_1.default.createElement("img", { src: request.store.logo_url, alt: request.store.name, className: "unreadRequestWindow-RequestItem_StoreIcon lazyload" }),
            !isOpened &&
                react_1.default.createElement("i", { className: "fa fa-circle unreadRequestWindow-RequestItem_UnreadDot" })),
        react_1.default.createElement("div", { className: "unreadRequestWindow-RequestItem_InnerBox" },
            react_1.default.createElement("div", { className: "unreadRequestWindow-RequestItem_ItemNameWrapper" },
                react_1.default.createElement("span", { className: itemNameClass }, request.item_names.length > 0 && request.item_names[0]),
                shouldShowItemCountLabel(request.item_names) && react_1.default.createElement("span", { className: "unreadRequestWindow-RequestItem_ItemNameLabel" },
                    "(\u307B\u304B",
                    request.item_names.length - 1,
                    "\u4EF6)")),
            react_1.default.createElement("div", { className: "unreadRequestWindow-RequestItem_Message" }, request.messages.length > 0 && react_1.default.createElement(RichText_1.default, { body: request.messages[0].body })),
            react_1.default.createElement("div", { className: "unreadRequestWindow-RequestItem_CreatedAt" }, formattedCreatedAt(request.created_at)))));
};
exports.default = RequestItem;
